import { type ComponentPropsWithoutRef, type FC } from 'react';
import { ListFilter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';

export const ToolbarFilterButton: FC<ComponentPropsWithoutRef<'button'> & { showFilterInput: boolean }> = ({
  showFilterInput,
  ...props
}) => {
  const tCommon = useTranslations('common');

  return (
    <Button
      variant="main-toolbar"
      className="mx-1 h-auto! min-h-auto! p-1 text-xs font-bold text-text-gray!"
      data-cy="toolbar-filter-button"
      icon={ListFilter}
      iconPosition="right"
      iconClassName={cn(
        'icon-5!',
        showFilterInput
          ? 'stroke-highlight-base! hover:stroke-highlight-hover-color!'
          : 'stroke-icon-base! hover:stroke-gray-icon-hover-color!',
      )}
      {...props}
    >
      {tCommon('filter')}
    </Button>
  );
};
